import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import msgConstants from '../../../../constants/msgConstants'
import { PAGES } from '../../../../router/routes'
import TransformacaoApiManager from '../../../../services/api/transformacaoApi/transformacaoApiManager'
import { loadingReset, loadingUpdate } from '../../../../store/actions/loadingAction'
import { GrupoRegra, RegraTransformacao } from '../../../../types/transformacaoApiTypes'
import { converterToAcaoTransformacaoForm, converterToCondicaoTransformacaoForm } from '../../../../utils/regraFormsUtils'
import { itemTransformacaoApiStyle } from './ItemTransformacaoApi.style'
import { ItemTransformacaoApiProps } from './ItemTransformacaoApi.View'

export function itemTransformacaoApiIO({ atualizarDados }: ItemTransformacaoApiProps) {
  const dispatch = useDispatch()
  const router = useHistory()
  const { parceiroId } = useParams<{ parceiroId: string }>()
  const [abrir, setAbrir] = useState(false)
  const [ancoraAtiva, setAncoraAtiva] = useState<null | HTMLElement>(null)

  const handleAlterarIconeAncora = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAncoraAtiva(event.currentTarget)
  }

  const handleAnularIconeAncora = () => {
    setAncoraAtiva(null)
  }

  const desativarRegraTransformacaoApi = (data: RegraTransformacao) => {
    dispatch(loadingUpdate(true))
    const dataEdit = {
      ...data,
      ativo: !data.ativo,
      grupos: data.grupos.map((item: GrupoRegra) => item.grupoId),
      acoes: converterToAcaoTransformacaoForm(data.acoes),
      condicoes: converterToCondicaoTransformacaoForm(data.condicoes)
    }

    TransformacaoApiManager.editarRegra(dataEdit, parceiroId, dataEdit.regraId)
      .then(() => {
        toast.success(msgConstants.USO_GENERICO.desativar_sucesso)
        atualizarDados()
      })
      .catch((error: Error) => {
        toast.error(error.message)
      })
    dispatch(loadingReset())
  }

  const editarRegraTransformacaoApi = (regraSelecionada: RegraTransformacao) => {
    router.push(PAGES.regraTransformacaoApiFormEditar(parceiroId, String(regraSelecionada.regraId)))
  }

  return {
    styles: itemTransformacaoApiStyle,
    abrir,
    handleAbrirToogle: () => setAbrir(!abrir),
    ancoraAtiva,
    handleAlterarIconeAncora,
    handleAnularIconeAncora,
    editarRegraTransformacaoApi,
    desativarRegraTransformacaoApi,
    parceiroId
  }
}

export type ItemTransformacaoApiIO = ReturnType<typeof itemTransformacaoApiIO>
